import { createAsyncThunk } from '@reduxjs/toolkit';
import { hyperPayService } from '../../../api';
import { PaginatedRequest } from '../../../types/api';

export const fetchHyperPaySessions = createAsyncThunk('hyper-pay/fetch-hyper-pay-sessions', (data: PaginatedRequest) =>
  hyperPayService.fetchSessions(data),
);
